document.addEventListener('DOMContentLoaded',function(){
  var select=document.querySelector('[data-print]');
  if(!select)return;
  var colors=[
    {name:'Aubergine',color:'#511654'},
    {name:'Blau',color:'#2468e8'},
    {name:'Blaumetallic',color:'#1768d4',swatch:'linear-gradient(135deg,#0b2d8f,#42a5ff,#164fb8,#7ec8ff,#0b2d8f)'},
    {name:'Bordeaux',color:'#7d180d'},
    {name:'Cyan',color:'#1599e8'},
    {name:'Gelb',color:'#fff000'},
    {name:'Goldmetallic',color:'#c99b2e',swatch:'linear-gradient(135deg,#76500d,#f7dc75,#a97513,#fff0a6,#82570d)'},
    {name:'Grau',color:'#74868b'},
    {name:'Grün',color:'#009b0c'},
    {name:'Leuchtrot',color:'#dd2b00'},
    {name:'Magenta',color:'#e6008d'},
    {name:'Maigrün',color:'#00e827'},
    {name:'Mandelbraun',color:'#713500'},
    {name:'Moosgrün',color:'#165900'},
    {name:'Rubinrot',color:'#58122b'},
    {name:'Schwarz',color:'#000000'},
    {name:'Silbermetallic',color:'#c9ced1',swatch:'linear-gradient(135deg,#666,#f8f8f8,#9ea4a8,#fff,#73787b)'},
    {name:'Weiß',color:'#ffffff'}
  ];
  select.innerHTML='';
  colors.forEach(function(c){var o=document.createElement('option');o.value=c.name;o.textContent=c.name;o.dataset.color=c.color;select.appendChild(o)});
  select.classList.add('visual-picker-select');
  var title=document.createElement('span');title.className='visual-picker-title';title.textContent='Druckfarbe auswählen';
  var grid=document.createElement('div');grid.className='print-picker';
  colors.forEach(function(c,i){var b=document.createElement('button');b.type='button';b.className='print-choice'+(i===0?' active':'');b.title=c.name;var sw=document.createElement('span');sw.className='print-choice-swatch';sw.style.background=c.swatch||c.color;var tx=document.createElement('small');tx.textContent=c.name;b.append(sw,tx);b.addEventListener('click',function(){select.selectedIndex=i;select.dispatchEvent(new Event('change',{bubbles:true}));grid.querySelectorAll('button').forEach(function(x){x.classList.remove('active')});b.classList.add('active')});grid.appendChild(b)});
  select.parentElement.append(title,grid);
  select.selectedIndex=0;
  select.dispatchEvent(new Event('change',{bubbles:true}));
});
